import React from 'react'
import { makeStyles } from '@material-ui/core'
import StarFull from '@mui/icons-material/Star'
import StarEmpty from '@mui/icons-material/StarOutline'
import ApiCalls from '../../../common/ApiCalls'
import IconButton from '@mui/material/IconButton'
import { useHMapContext } from '../hooks/useHMapContext'

const HMapContainerStar = ({
  id,
  name,
  star,
  className,
  disabled,
  type,
  allHeatMaps,
  setAllHeatMaps,
  setShowLoader
}) => {
  const classes = useStyles({ star, disabled })
  const { userIdRef, snackbar } = useHMapContext()
  const [isSnackbarOpen, setIsSnackbarOpen] = snackbar
  const userId = userIdRef.current

  const toggleHandler = () => {
    // Show Loader
    setShowLoader(true)

    // favorite functions
    const { addHeatmapAttribute, removeHeatmapAttribute } = ApiCalls()

    // add or remove favorite
    const currentMapDetails = allHeatMaps.filter((item) => item.id === id)
    const { star } =
      currentMapDetails && currentMapDetails.length && currentMapDetails[0]

    // favorite function based on the current favorite value
    const starFunction = !star ? addHeatmapAttribute : removeHeatmapAttribute

    starFunction(userId, id, 'favorite')
      .then((data) => {
        // added timeout to prevent consequent clicks
        // minimum wait = 0.5s
        setTimeout(() => {
          // add or remove favorite from the heatmap
          setAllHeatMaps([
            ...allHeatMaps.map((item) =>
              item.id === id ? { ...item, star: !star } : item
            )
          ])
          // Show Loader
          setShowLoader(false)

          // display snackbar with success message
          setIsSnackbarOpen({
            ...isSnackbarOpen,
            message: `You heatmap is ${
              star ? 'removed from' : 'added to'
            } the favorite list`,
            severity: 'success',
            isOpen: true
          })
        }, 500)
      })
      .catch((err) => {
        // Show Loader
        setShowLoader(false)
        // display snackbar with error message
        setIsSnackbarOpen({
          ...isSnackbarOpen,
          message: err.message,
          severity: 'fail',
          isOpen: true
        })
      })
  }

  const iconButtonProps = {
    name: `${name}_star`,
    'aria-label': 'expand row',
    size: 'small',
    ...(className && { className: `${classes.root} ${className}` }),
    ...(!disabled && { onClick: toggleHandler })
  }

  return (
    <IconButton {...iconButtonProps}>
      {star ? (
        <StarFull className={classes.iconFull} />
      ) : (
        <StarEmpty className={classes.iconEmpty} />
      )}
    </IconButton>
  )
}

export default React.memo(HMapContainerStar)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '20px',
    height: '20px'
  },
  iconFull: {
    width: '20px',
    height: '20px',
    color: theme.palette.primary.accent,
    fill: theme.palette.primary.accent
  },
  iconEmpty: {
    width: '20px',
    height: '20px',
    color: theme.palette.tertiary.accent,
    fill: theme.palette.tertiary.accent
  }
}))
